import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';
import { TPepEntity } from '~/modules/identification/forms/AdditionalInformation/types.ts';
import { pepValidationSchema } from '~/modules/identification/forms/AdditionalInformation/validationSchema.ts';
import { useMemo } from 'react';
import { emptyPep } from '~/modules/identification/forms/AdditionalInformation/constants.ts';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes.ts';
import { selectAdditionalInformation } from '~/store/identification-form/selectors';

export const useAdditionalInformationForm = () => {
  const additionalInformation = useSelector(selectAdditionalInformation) ?? [];
  const { isSoleTrader } = useGetContragentTypes();
  const { isCRSIFopEnabled } = useFeatureFlags();

  const initialValues = useMemo(
    () => (additionalInformation?.length ? additionalInformation : [emptyPep]),
    [additionalInformation]
  );

  const schema = yup.object({
    additionalInformation: pepValidationSchema(isCRSIFopEnabled, isSoleTrader),
  });

  const form = useForm<{ additionalInformation: Array<TPepEntity> }>({
    resolver: yupResolver(schema) as unknown as Resolver<{
      additionalInformation: Array<TPepEntity>;
    }>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: { additionalInformation: cloneDeep(initialValues) },
  });

  return form;
};
